import { Button } from '@forwardflow/ui'
import { Modal } from 'antd'

interface FubInboxInstallModalProps {
   open: boolean
   onInstall: () => void
   onSkip: () => void
}

export const FubInboxInstallModal: React.FC<FubInboxInstallModalProps> = ({
   open,
   onInstall,
   onSkip,
}) => (
   <Modal
      className="ff-modal"
      open={open}
      onCancel={onSkip}
      closable={false}
      centered
      footer={null}
   >
      <div className="text-[18px] font-medium text-center">
         <div className="mb-4">
            You have requested for FUB Inbox APP.
            <br />
            Do you want to install it now?
         </div>
      </div>
      <div className="flex justify-end gap-4 mt-6">
         <Button
            key="skip"
            className="h-12 px-4 py-2 font-semibold !border-none text-white rounded-md bg-white/5 hover:!bg-gray-600 w-44"
            onClick={onSkip}
         >
            Skip
         </Button>

         <Button
            key="install"
            className="!bg-primary !text-white border-none hover:!bg-primary/80"
            onClick={onInstall}
         >
            Install
         </Button>
      </div>
   </Modal>
)
